import { combineReducers } from 'redux';

const INIT_STATE = {
  counter: 0,
  data: [],
}

function taskReducer(state = INIT_STATE, action) {
  switch(action.type) {
    case 'SHOW_TASKS_COUNT': {
      const { payload } = action;
      const { data, counter } = payload;

      return {
        ...INIT_STATE,
        counter,
        data: [...data],
      };
    }

    default : {
      return state;
    }
  }
}


const reducers = combineReducers({
  tasks: taskReducer || {}
});

export const notificationReducer = (state, action) => {
  return reducers(state, action);
};